import { useEffect, useState } from 'react';
import './style.css'
type Props = {}
const SiteLoader = (props: Props) => {

  const loadingMessages = [
    "Cooking up some tasty data...",
    "Sprinkling some digital spices...",
    "Gathering the ingredients of the internet...",
    "Did you know a 'jiffy' is an actual unit of time? ⏱️",
    "Be patient, good things take time... like pizza 🍕",
    "Almost there, just untangling the virtual pasta...",
  ];

  const [message, setMessage] = useState('');

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * loadingMessages.length);
    setMessage(loadingMessages[randomIndex]);
  }, []); // The empty dependency array ensures this runs only once when the component mounts.

  return (

    <div className='h-screen w-screen flex items-center justify-center flex-col gap-0'>
      <div className='flex flex-col items-center'>
        <span className="loader-2" ></span>
        <span className='mt-10 text-gray-400 font-semibold animate-pulse text-sm'>Loading...</span>
      </div>
    </div>
  )
}

export default SiteLoader